import * as z from "zod";
import { OutboundShipmentTaxIdSchema } from "./customs";

const landedCostBillingSchema = z.object({
  taxIdentifiers: z.array(OutboundShipmentTaxIdSchema),
  thirdPartyBillingAccount: z.string(),
  billingCountryCode: z.string(),
  billingPostalCode: z.string().nullish(),
});
export const LandedCostBillingSchema: z.ZodType<LandedCostBuyOptionsBilling> =
  landedCostBillingSchema;
export type LandedCostBuyOptionsBilling = z.infer<
  typeof landedCostBillingSchema
>;
